export const Config = {
  api: {
    uri: process.env.NODE_ENV === "development" ? "https://localhost:7000/api" : "https://api.srdaycare.com/api",
  },
  googleAuth: {
    clientId: "887528560092-lnsv43ukmoeq934dvk5bt9tejgt6p9fu.apps.googleusercontent.com",
    oauthUrl: "https://accounts.google.com/o/oauth2/v2/auth",
    scopes: [
      "https://www.googleapis.com/auth/userinfo.email",
      "https://www.googleapis.com/auth/userinfo.profile",
      "openid",
      "https://www.googleapis.com/auth/gmail.send",
    ],
    redirectUri: process.env.NODE_ENV === "development" ? "http://localhost:5173" : "https://hub.srdaycare.com",
  },
};

export default Config;
